import { render, staticRenderFns } from "./spareRequirementsUpdate.vue?vue&type=template&id=002b7b99&scoped=true"
import script from "./spareRequirementsUpdate.vue?vue&type=script&lang=js"
export * from "./spareRequirementsUpdate.vue?vue&type=script&lang=js"
import style0 from "./spareRequirementsUpdate.vue?vue&type=style&index=0&id=002b7b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b7b99",
  null
  
)

export default component.exports